import {generateFilterKey} from "./GenerateKey";

export const filterCaseDataByFilterMenu = (workflowIndex, caseStateId) => {
    const key = generateFilterKey(workflowIndex, caseStateId);
    const filterArray = JSON.parse(localStorage.getItem(key));

    // Return empty array if filterArray is null or empty
    if (!filterArray || !Array.isArray(filterArray) || filterArray.length === 0) {
        return [];
    }

    const filterMap = filterArray.reduce((acc, filter) => {
        if (filter.selectedOptions && filter.selectedOptions.length > 0) {
            let fieldKey = filter.field;
            if (fieldKey.startsWith('metadata.') && fieldKey.endsWith('.value')) {
                fieldKey = fieldKey.split('.')[1];
            } else if (fieldKey.startsWith('auditInfo.')) {
                fieldKey = fieldKey.split('.')[1];
            }
            acc[fieldKey] = filter.selectedOptions.map(option => option.value);
        }
        return acc;
    }, {});

    // Transform filterMap to filters array format
    return Object.entries(filterMap).map(([field, values]) => ({
        field,
        values
    }));
}